import PageNotFoundError from '../../domain/error/PageNotFoundError'
import PermanentRedirectError from '../../domain/error/PermanentRedirectError'
import { bboxArrayToBboxArrays } from '../../domain/map/conversion'
import { generateFullRoute } from '../../domain/router/routeUtils'
import { renderPage } from '../../domain/seo/zones/bicycle-zone.page'
import { extractCodeLabel } from '../../domain/utils/location'
import { searchArea } from '../../store/address/address.actions'
import { selectFirstAddress } from '../../store/address/address.selectors'
import { MAP_MODES } from '../../store/map/map.constants'
import { mapUpdated, setMapMode } from '../../store/map/mapSlice'
import { selectIsFrenchSite } from '../../store/navigation/navigation.selectors'
import { geocodeForwardCtx } from '../../store/search/search.service.constants'
import { setSearchTerms } from '../../store/search/searchSlice'
import { loadSeoLayerFaq } from '../../store/seo/seo-faq.actions'
import {
  redirectLayerDepartmentRouteIfTownUpperCased,
  searchLayerZoneDescription
} from '../../store/seo/seo-zone.actions'
import { slugify } from '../../utils/string'
import { ROUTE_BICYCLE_DEPARTMENT } from '../index'
import { technicalErrorCatcher } from '../routeErrors.utils'
import { handleRouteLoading } from '../routeService'

export const onRouteEnter = ({ params, store: { dispatch, getState } }) => {
  if (!selectIsFrenchSite(getState())) throw new PageNotFoundError('bicycle department accessed from foreign site')

  const { location } = params
  const { code, label } = extractCodeLabel(location)

  if (__SERVER__) {
    redirectLayerDepartmentRouteIfTownUpperCased(code, label, ROUTE_BICYCLE_DEPARTMENT)
  }

  return searchArea(location, geocodeForwardCtx.filter.county)(dispatch, getState)
    .then(() => {
      const firstAddress = selectFirstAddress(getState())

      if (firstAddress.departmentCode !== code || slugify(firstAddress.departmentLabel) !== label)
        throw new PermanentRedirectError(
          generateFullRoute(ROUTE_BICYCLE_DEPARTMENT, {
            location: `${firstAddress.departmentCode}-${slugify(firstAddress.departmentLabel)}`
          })
        )

      return Promise.all([
        dispatch(setMapMode(MAP_MODES.bicycle)),
        dispatch(setSearchTerms(location)),
        searchLayerZoneDescription(MAP_MODES.bicycle)(dispatch, getState),
        loadSeoLayerFaq('bicycle-department')(dispatch, getState),
        dispatch(mapUpdated({ bbox: bboxArrayToBboxArrays(firstAddress.bbox) }))
      ])
    })
    .catch(technicalErrorCatcher)
}

export default handleRouteLoading({ onRouteEnter, renderPage })
